module.exports = __webpack_public_path__ + "img/ogp_og_big.b57db400.jpg";